
const _directiveDependencies = ['Templates'];
const _controllerDependencies = ['Util', '$scope'];

class PhoneSmsDeploymentSuccessController {

    constructor(Util, $scope) {

        this.Util = Util;
        this.$scope = $scope;

    }

    close() {

        this.Util.closeModal();

    }

    resendSms() {

        this.$scope.inputData = {
            appId: this.$scope.inputData.appId,
            os: this.$scope.inputData.os,
        };

        this.$scope.dynamicDirectiveTag = '<phone-deployment-wizard />';

    }

}

class PhoneSmsDeploymentSuccessDirective {

    constructor() {

        this.template = require('./phone-sms-deployment-success.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push((Util, $scope) =>
            new PhoneSmsDeploymentSuccessController(Util, $scope));

        this.controller = _controllerDependencies;
        this.controllerAs = 'PhoneSmsDeploymentSuccessCtrl';

    }

}

_directiveDependencies.push(() =>
    new PhoneSmsDeploymentSuccessDirective());

angular.module('directives')
    .directive('phoneSmsDeploymentSuccess', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/deployment/phone-sms-deployment-success/phone-sms-deployment-success.js